import React, { useState } from 'react';
import './header.css';

/* const CustomLogo = () => (
  <svg
    width="40"
    height="36"
    viewBox="0 0 40 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2001_37)">
      <rect width="40" height="36" rx="2" fill="white" />
      <path
        d="M-1.30511 37V-0.800003H5.93089L22.0229 25.876H18.1889L34.0109 -0.800003H41.1929L41.3009 37H33.0929L33.0389 11.782H34.5509L21.9149 33.004H17.9729L5.06689 11.782H6.90289V37H-1.30511Z"
        fill="black"
      />
      <path
        d="M20.1339 16.232C18.7999 16.232 17.5142 16.0773 16.2769 15.768C15.0589 15.4393 14.0922 15.0333 13.3769 14.55L14.8849 11.302C15.6002 11.7467 16.4412 12.114 17.4079 12.404C18.3939 12.6747 19.3605 12.81 20.3079 12.81C21.3519 12.81 22.0865 12.6843 22.5119 12.433C22.9565 12.1817 23.1789 11.8337 23.1789 11.389C23.1789 11.0217 23.0049 10.751 22.6569 10.577C22.3282 10.3837 21.8835 10.2387 21.3229 10.142C20.7622 10.0453 20.1435 9.94867 19.4669 9.852C18.8095 9.75533 18.1425 9.62967 17.4659 9.475C16.7892 9.301 16.1705 9.04967 15.6099 8.721C15.0492 8.39233 14.5949 7.94767 14.2469 7.387C13.9182 6.82633 13.7539 6.10133 13.7539 5.212C13.7539 4.226 14.0342 3.356 14.5949 2.602C15.1749 1.848 16.0062 1.25833 17.0889 0.833C18.1715 0.388333 19.4669 0.166 20.9749 0.166C22.0382 0.166 23.1209 0.282 24.2229 0.513999C25.3249 0.745999 26.2432 1.08433 26.9779 1.529L25.4699 4.748C24.7159 4.30333 23.9522 4.00367 23.1789 3.849C22.4249 3.675 21.6902 3.588 20.9749 3.588C19.9695 3.588 19.2349 3.72333 18.7709 3.994C18.3069 4.26467 18.0749 4.61267 18.0749 5.038C18.0749 5.42467 18.2392 5.71467 18.5679 5.908C18.9159 6.10133 19.3702 6.256 19.9309 6.372C20.4915 6.488 21.1005 6.59433 21.7579 6.691C22.4345 6.76833 23.1112 6.894 23.7879 7.068C24.4645 7.242 25.0735 7.49333 25.6149 7.822C26.1755 8.13133 26.6299 8.56633 26.9779 9.127C27.3259 9.66833 27.4999 10.3837 27.4999 11.273C27.4999 12.2397 27.2099 13.1 26.6299 13.854C26.0499 14.5887 25.2089 15.1687 24.1069 15.594C23.0242 16.0193 21.6999 16.232 20.1339 16.232Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2001_37">
        <rect width="40" height="36" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
); */

const Header = () => {
    /*=============== Change Background Header ===============*/
    window.addEventListener("scroll", function(){
        const header = document.querySelector(".header");
        // when the scroll is higher than 200 viewport height, the 
        // "scroll-header" class is added to a tag with the header tag
        if(this.scrollY >= 80) header.classList.add("scroll-header");
        else header.classList.remove("scroll-header");
    });
    /*=============== Toggle Menu ===============*/
    const [Toggle, showMenu] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");
  return (
    <header className="header">
        <nav className="nav container">
            <a href="index.html" className="nav__logo">
                Suhaib.
            </a>

            <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                <ul className="nav__list grid">
                    <li className="nav__item">
                        <a href="#home" onClick={() => setActiveNav('#home')}  className={activeNav === "#home"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-estate nav__icon"></i> Home
                        </a>
                    </li>
                    <li className="nav__item">
                        <a href="#about" onClick={() => setActiveNav('#about')}  className={activeNav === "#about"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-user nav__icon"></i> About
                        </a>
                    </li>
                    <li className="nav__item">
                        <a href="#skills" onClick={() => setActiveNav('#skills')}  className={activeNav === "#skills"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-file-alt nav__icon"></i> Skills
                        </a>
                    </li>
                    <li className="nav__item">
                        <a href="#qualification" onClick={() => setActiveNav('#qualification')}  className={activeNav === "#qualification"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-briefcase-alt nav__icon"></i> Qualification
                        </a>
                    </li>
                    {/*<li className="nav__item">
                        <a href="#services" onClick={() => setActiveNav('#services')}  className={activeNav === "#services"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-briefcase-alt nav__icon"></i> Services
                        </a>
                    </li>*/}
                    <li className="nav__item">
                        <a href="#portfolio" onClick={() => setActiveNav('#portfolio')}  className={activeNav === "#portfolio"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-scenery nav__icon"></i> Portfolio
                        </a>
                    </li>
                    <li className="nav__item">
                        <a href="#contact" onClick={() => setActiveNav('#contact')}  className={activeNav === "#contact"? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-message nav__icon"></i> Contact
                        </a>
                    </li>
                </ul>

                <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
            </div>

            <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                <i className="uil uil-apps"></i>
            </div>
        </nav>
    </header>
  )
}

export default Header